/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Breakpoint } from 'react-socks';

class FeedSearchResult extends React.Component {
    constructor(props) {
        super(props);

        this.viewFeed = this.viewFeed.bind(this);
    }

    viewFeed(e) {

        // keep the 'view' click from triggering adding a feed
        e.stopPropagation();

    }

    render() {
        let iconUrl = this.props.result.visualUrl,
            sourceIcon = null,
            connectControl = null,
            description = '',
            title = null,
            preview = null,
            icon = null;

        if (iconUrl && iconUrl.match('http://')) {
            iconUrl = iconUrl.replace('http://', 'https://');
        }

        if (iconUrl !== '') {
            sourceIcon = (
                <div className="inline-icon">
                    <img src={iconUrl} className="inline-icon-img" onError={() => { this.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="; }} />
                </div>
            );
        } else {
            sourceIcon = (
                <div className="inline-icon">
                    <i className="icon ion-social-rss feed-placeholder"></i>
                </div>
            );
        }

        if (this.props.result.isError === undefined || this.props.result.isError === false) {
            description = this.props.result.description;
            connectControl = (
                <div className="connect-button" onClick={(e) => { this.props.selectFeed(this.props.result, e) }} role="button" aria-label="connect">
                    Connect
                </div>
            );
            title = (
                <div className="source-title" onClick={(e) => { this.props.selectFeed(this.props.result, e) }} role="button" aria-label="connect">
                    {this.props.result.title}
                </div>
            );
            preview = (
                <div className="source-preview">
                    <a href={"/feedPreview.php?url=" + encodeURIComponent(this.props.result.url)} className="feed-search-preview" onClick={this.viewFeed} target="_blank">
                        view
                    </a>
                </div>
            );
            icon = (
                <div className="source-icon" onClick={(e) => { this.props.selectFeed(this.props.result, e) }}>
                    {sourceIcon}
                </div>
            );
        } else {
            description = (
                <span className="error">{this.props.result.description}</span>
            );
            title = (
                <div className="source-title">
                    {this.props.result.title}
                </div>
            );
            sourceIcon = (
                <div className="inline-icon">
                    <i className="icon ion-social-rss feed-placeholder error"></i>
                </div>
            );
            icon = (
                <div className="source-icon">
                    {sourceIcon}
                </div>
            );
            preview = (
                <div className="source-preview">
                    <span>{"\u00A0"}</span>
                </div>
            );
            connectControl = (
                <span>{"\u00A0"}</span>
            );
        }

        return (
            <li className="feed-search-result">
                <Breakpoint desktop only>
                    {icon}
                    <div className="source-info">
                        {title}
                        <div className="source-desc">{description}</div>
                        {preview}
                    </div>
                    <div className="source-controls">
                        {connectControl}
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="mobile-feed-info">
                        {icon}
                        <div className="source-info">
                            {title}
                            <div className="source-desc mobile">{description}</div>
                            {preview}
                        </div>
                    </div>
                    <div className="mobile-feed-action">
                        <div className="source-controls">
                            {connectControl}
                        </div>
                    </div>
                </Breakpoint>
            </li>
        );
    }
}

FeedSearchResult.displayName = "FeedSearchResult";

FeedSearchResult.propTypes = {
    result: PropTypes.object,
};

FeedSearchResult.defaultProps = {
    result: {},
};

export default FeedSearchResult;
